<section
  [ngClass]="{
    'col-f md-col-3-10': currentStep.id === BOOKING_STEPS.PURCHASE_REVIEW.id,
    'ms-large-t': isTabletDown,
    'pr-large-y': !isTabletDown,
  }"
  class="flex flex--center flex--space-between relative fill"
>
  <div
    *ngFor="let step of breadcrumbs; let i = index; let isLast = last"
    class="step flex relative grow flex--center flex--grow"
    [class.no-grow]="isLast && !isTabletDown"
    [class.flex--column]="isTabletDown"
  >
    <div class="step-content flex flex--center flex--column">
      <fcom-icon-button
        class="tooltip-button"
        [size]="IconButtonSize.LARGE"
        [theme]="step.active ? IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE : IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{ name: i < activeIndex && !isTabletDown ? SvgLibraryIcon.CHECKMARK : step.icon }"
        [disabled]="step.disabled || i > activeIndex"
        [aria]="{
          label: step.name,
          labelledby: step.name + '-title',
        }"
        (clickBtn)="onBreadcrumbClick(step, i)"
        (pointerdown)="handleDisabledClick($event, step, i)"
      ></fcom-icon-button>

      <div
        *ngIf="!isTabletDown"
        [class.medium-type]="step.active"
        [ngClass]="i > activeIndex ? 'grey-600-text' : 'nordic-blue-900-text'"
        class="step-title font-body-1 ms-xsmall-t absolute nowrap"
      >
        {{ step.name }}
      </div>
    </div>
    <div
      *ngIf="(isTabletDown && i < breadcrumbs.length) || (!isTabletDown && i < breadcrumbs.length - 1)"
      class="progress-connector grey-200-bg flex--self-start"
      [style.width.%]="isTabletDown ? 100 : 0"
      [ngClass]="{
        'ms-medium-y': isTabletDown,
        'border-all ms-large-t ms-small-x': !isTabletDown,
        'border-radius-left': isTabletDown && i === 0,
        'border-radius-right': isTabletDown && i === breadcrumbs.length - 1,
        'nordic-blue-900-bg': i < activeIndex || (isTabletDown && step.active),
      }"
    ></div>
  </div>
</section>
